export default __webpack_public_path__ + "static/media/track-elements-geo-dot.0983b33a.svg";